import { CSSProperties, ReactNode } from "react";
import { ConfigurationItem, OrderTypes, PrecisionConfig } from "@shared/types";

export interface ConfigurationItemRowProps {
  nameComponent: ReactNode;
  extraInfoComponent?: ReactNode;
  overrideComponent?: ReactNode;
  onClickRow?: () => void;
  inactive?: boolean;
  selected?: boolean;
  extraInfoAlignRight?: boolean;
  deleteHandler?: () => void;
  editHandler?: () => void;
  itemValueModified?: boolean;
  isFocused?: boolean;
  validationMessage?: ReactNode;
  isError?: boolean;
  innerComponent?: ReactNode;
  defaultExpanded?: boolean;
  expanded?: boolean;
  onExpandChange?: (expanded: boolean) => void;
  type?: "simple";
  expandExtraInfoOnClickRow?: boolean;
  wrapperId?: string;
  errorMessage?: string;
  extraInfoComponentFlex?: string;
  isColoredIcons?: boolean;
  showRadioButton?: boolean;
  setItemToEdit?: () => void;
  hideEditAndRemove?: boolean;
  style?: CSSProperties;
}

export enum HedgeMode {
  HEDGE_MODE = "Hedge Mode",
  ONE_WAY_MODE = "One-Way Mode",
}

export interface UseGeneralConfigurationProps {
  configuration: ConfigurationItem | undefined;
  editable?: boolean;
  showOverrides?: boolean;
  colorModifiedValues?: boolean;
  precisionConfig?: PrecisionConfig;
  extraParams?: any;
  spacing?: number;
  extraInfoAlignRight?: boolean;
  useCard?: boolean;
  useSimpleLayout?: boolean;
  addEditWarningMessage?: boolean;
  isForm?: boolean;
  orderType?: OrderTypes;
  useDefaultPopupContainer?: boolean;
}

export enum ConnectExternalAccountStep {
  CREATE_ACCOUNT = "Create Account",
  SELECT_EXCHANGE = "Select Exchange",
  CONNECT_EXCHANGE = "Connect Exchange",
  SUCCESS = "Success",
}
